<template>
  <!--begin::List Widget 4-->
  <div class="card card-custom card-stretch gutter-b" id="cyber-list">
    <!--begin::Header-->
    <div class="card-header border-0">
      <h3 class="card-title font-weight-bolder text-dark-75">
        {{ $t("messages.dashboard.cybersecurity.list") }}
      </h3>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body pt-2">
      <div
        v-for="dimension in cyberDimensions"
        :key="dimension.id"
        style="position: relative;"
      >
        <!--begin::Item-->
        <div class="d-flex align-items-center mb-5">
          <!--begin::Bullet-->
          <span
            :class="
              'bullet bullet-bar ' +
                getStatusClass(dimension.score) +
                ' align-self-stretch'
            "
          ></span>
          <!--end::Bullet-->
          <!--begin::Checkbox-->
          <label
            :class="
              'checkbox checkbox-lg ' +
                getStatusClass(dimension.score) +
                ' checkbox-single flex-shrink-0 m-0 mx-4'
            "
            style="cursor: auto;"
          >
            <input type="checkbox" disabled />
            <span style="background: none; " class="pl-1 pb-1">
              <span
                :class="getStatusClass(dimension.score)"
                :style="{
                  display: 'contents',
                  fontWeight: 'bold',
                  height: '100%',
                  width: '100%'
                }"
              >
                {{
                  dimension.score !== false || dimension.score !== undefined
                    ? $n(dimension.score / 10, "percent")
                    : "?"
                }}
                <!--end::Svg Icon-->
              </span>
            </span>
          </label>
          <!--end::Checkbox-->
          <!--begin::Text-->
          <div class="d-flex d-flex align-items-center justify-content-between">
            <div
              class="text-dark-75 font-weight-bold font-size-lg mb-1 text-left mr-1"
              v-html="dimension.name"
            />
          </div>
          <!--end::Text-->
        </div>
        <!--end:Item-->
        <span
          :class="
            `label label-light ${getStatusClass(
              dimension.score
            )} font-weight-bolder label-inline cyber-label`
          "
        >
          {{ $t(`messages.dashboard.sessions.status.${dimension.status}`) }}
        </span>
      </div>
    </div>
    <!--end::Body-->
  </div>
  <!--end:List Widget 4-->
</template>

<script>
import _ from "lodash";
import { getClassByValueAndBase } from "@/utils/helpers";
import { mapGetters } from "vuex";

export default {
  name: "Sessions",
  props: {
    dimensions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("Constants", ["getConstant"]),
    cyberDimensions() {
      var result = [];
      _.forEach(this.dimensions, e => {
        let status = "";
        if (e.value === false) status = "undefined";
        else if (e.value < 5) status = "bad";
        else if (e.value < 6.5) status = "fair";
        else if (e.value < 8) status = "good";
        else status = "excelent";
        result.push({
          id: e.id,
          name: this.$t(`messages.dashboard.cybersecurity.${e.name}`),
          score: e.value,
          status: status
        });
      });
      return _.orderBy(result, e => e.score, ["desc"]);
    }
  },
  methods: {
    getStatusClass(value) {
      return getClassByValueAndBase(value, 10, true, true);
    }
  }
};
</script>

<style lang="scss">
#cyber-list .checkbox.checkbox-lg.checkbox-single {
  height: 32px;
  width: 40px;
  border-radius: 5px;
  span {
    height: 32px;
    width: 40px;
  }
}
.cyber-label {
  position: absolute;
  top: 0;
}
@media (max-width: 768px) {
  .cyber-label {
    position: absolute;
    top: 0;
    right: -15px;
  }
}
@media (max-width: 1024px) and (min-width: 769px) {
  .cyber-label {
    position: absolute;
    top: 0;
    right: 0px;
  }
}
</style>
